// src/redux/companySession/companySessionApi.js
import { endpoints } from "../apiEndpoints/apiEndpoints";
import apiService from "../services/apiCore";

// ✅ Create Company Session
export const createCompanySessionAPI = async (companyId, sessionData) => {
  try {
    const endpoint = endpoints.createCompanySession.replace('{company_id}', companyId);
    const response = await apiService.post(endpoint, sessionData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Get Company Sessions
export const getCompanySessionsAPI = async ({
  company_id,
  page = 1,
  limit = 10,
  search = "",
  from_date = null,
  to_date = null,
  session_type
} = {}) => {
  try {
    const params = { page, limit, search, company_id, from_date, to_date };
    if (session_type) params.session_type = session_type;
    const response = await apiService.get(endpoints.getCompanySessions, params);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Get Company Session Detail (GET with path parameters)
export const getCompanySessionDetailAPI = async (companyId, sessionId) => {
  try {
    const endpoint = endpoints.getCompanySessionDetail
      .replace('{company_id}', companyId)
      .replace('{company_session_id}', sessionId);
    const response = await apiService.get(endpoint);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Get Particular Session Details (POST with request body)
// POST /company/sessions/particular-details
// Body: { company_id: 12, company_session_id: 45 }
export const getParticularSessionDetailsAPI = async (companyId, companySessionId) => {
  try {
    const endpoint = endpoints.getParticularSessionDetails;
    const payload = {
      company_id: companyId,
      company_session_id: companySessionId
    };
    const response = await apiService.post(endpoint, payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Enable Tool Access
// POST /company/sessions/enable-tool
export const enableToolAccessAPI = async (companyId, toolData) => {
  try {
    const endpoint = endpoints.enableToolAccess;
    // Expected body: { company_id, company_session_id, tool_enabled, tool_id, batch_ids, is_locked }
    const payload = {
      company_id: companyId,
      ...toolData
    };
    const response = await apiService.post(endpoint, payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Enable Support Document
// POST /company/sessions/enable-support-document
export const enableSupportDocumentAPI = async (companyId, documentData) => {
  try {
    const endpoint = endpoints.enableSupportDocument;
    // Expected body: { company_id, company_session_id, supported_doc_enabled, supported_doc_id, batch_ids }
    const payload = {
      company_id: companyId,
      ...documentData
    };
    const response = await apiService.post(endpoint, payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Enable Assignment
// POST /company/sessions/enable-assignment
export const enableAssignmentAPI = async (companyId, assignmentData) => {
  try {
    const endpoint = endpoints.enableAssignment;
    // Expected body: { company_id, company_session_id, assignment_enabled, assignment_id, batch_ids }
    const payload = {
      company_id: companyId,
      ...assignmentData
    };
    const response = await apiService.post(endpoint, payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Enable / Disable Company Session for all employees assigned to it
// POST /company/sessions/enable
export const enableCompanySessionAPI = async (companyId, body) => {
  try {
    const endpoint = endpoints.enableCompanySession;
    const payload = { company_id: companyId, ...body };
    const response = await apiService.post(endpoint, payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};